import React, {Component} from 'react';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';
import withQuery from 'utils/withQuery';

export const query = gql`
    query seoLinkpileQuery($path: String) {
        seoLinkpile(path: $path) {
            title
            categories {
                title
                links {
                    text
                    url
                }
            }
        }
    }
`;

const SeoLinkpileLoaded = (props) => {
    const {
        site,
        isMobile,
        response: {
            data: {seoLinkpile, loading, error},
        },
    } = props;
    const defaultProps = {
        forceExpanded: true,
        categories: [],
        site,
        isMobile,
    };

    if (loading || error || !seoLinkpile) {
        return null;
    }

    return (
        <CollapsibleLinkpile
            {...{
                ...defaultProps,
                ...seoLinkpile,
            }}
        />
    );
};

const SeoLinkpileWithLoading = withQuery(SeoLinkpileLoaded);

export default class SeoLinkpile extends Component {
    render() {
        const {canonicalLink, site, ...rest} = this.props;
        const variables = {
            path: canonicalLink,
            site,
        };

        return (
            <Query {...{query, variables}}>
                {(response) => {
                    return <SeoLinkpileWithLoading {...{...rest, response}} />;
                }}
            </Query>
        );
    }
}
